'use client';

import React from 'react';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import { DRIFT_TOKEN_BANK_INDEX } from 'src/environmentVariables/EnvironmentVariables';
import { cj } from 'src/utils/classNames';
import { useSpotMarketsLookup } from 'src/hooks/spotMarkets/useSpotMarketsLookup';
import useModal from 'src/components/Modals/hooks/useModal';
import Button from 'src/components/primitives/Button/Button';
import { Z_INDEX } from 'src/constants/zIndex';
import useWalletIsConnected from 'src/hooks/useWalletIsConnected';

export default function DriftStakingMobileBottomBar() {
	const isWalletConnected = useWalletIsConnected();
	const isGeoblocked = useDriftStore((s) => s.isGeoblocked);
	const driftSpotMarket = useSpotMarketsLookup()[DRIFT_TOKEN_BANK_INDEX];
	const isMobileScreenSize = useIsMobileScreenSize();
	const { show } = useModal();

	if (!isMobileScreenSize || !isWalletConnected) {
		return null;
	}

	const handleOpenStakeModal = () => {
		show({
			type: 'stake',
			props: { isDriftStaking: true, selectedIfStakeMarket: driftSpotMarket },
		});
	};

	const handleOpenUnstakeModal = () => {
		show({
			type: 'stake',
			props: {
				isDriftStaking: true,
				selectedIfStakeMarket: driftSpotMarket,
				initialTab: 'unstake',
			},
		});
	};

	return (
		<div
			className={cj(
				'fixed inset-x-0 bottom-0 flex items-center justify-center',
				'flex gap-x-md border-t border-stroke-divider bg-container-bg p-lg',
				'rounded-t-sm',
				Z_INDEX.mobileBottomBar
			)}
		>
			<Button
				size="lg"
				variant="primary"
				className="w-full"
				onClick={handleOpenStakeModal}
				disabled={isGeoblocked}
			>
				Stake
			</Button>
			<Button
				size="lg"
				variant="secondary"
				className="w-full"
				onClick={handleOpenUnstakeModal}
			>
				Unstake
			</Button>
		</div>
	);
}
